import React from 'react'
import { useAdminSubscriptionsTableData } from './hooks/useTableData'
import { SubscriptionsFilters } from './components/SubscriptionsFilters'
import { SubscriptionsSummary } from './components/SubscriptionsSummary'
import { SubscriptionsTable } from './components/SubscriptionsTable'
import { useSubscriptionsTableState } from './hooks/useSubscriptionsTableState'
import {
  SubscriptionsFiltersSection,
  SubscriptionsHeaderSection,
  SubscriptionsPaper,
} from './styles'

interface Props {
  onCustomerOptionsChange?: (
    customers: Array<{
      customerProfileId: number
      customerName: string
      email: string
      phoneNumber: string
    }>
  ) => void
  tableHeight?: number | string
  tableMinHeight?: number
}

export const AdminSubscriptionsTableComponent: React.FC<Props> = ({
  onCustomerOptionsChange,
  tableHeight = '100%',
  tableMinHeight = 420,
}) => {
  const { rows, loading, error } = useAdminSubscriptionsTableData()
  const {
    expandedRows,
    filters,
    onChangeFilter,
    onSort,
    onToggleRow,
    sortDirection,
    sortKey,
    statusOptions,
    summary,
    visibleRows,
  } = useSubscriptionsTableState(rows)

  React.useEffect(() => {
    if (!onCustomerOptionsChange) return

    const uniqueCustomers = new Map<
      number,
      {
        customerProfileId: number
        customerName: string
        email: string
        phoneNumber: string
      }
    >()

    for (const row of rows) {
      uniqueCustomers.set(row.customerProfileId, {
        customerProfileId: row.customerProfileId,
        customerName: row.customerName,
        email: row.email,
        phoneNumber: row.phoneNumber,
      })
    }

    onCustomerOptionsChange([...uniqueCustomers.values()])
  }, [onCustomerOptionsChange, rows])

  return (
    <SubscriptionsPaper>
      <SubscriptionsHeaderSection>
        <SubscriptionsSummary summary={summary} />
      </SubscriptionsHeaderSection>
      <SubscriptionsFiltersSection>
        <SubscriptionsFilters
          filters={filters}
          onChangeFilter={onChangeFilter}
          statusOptions={statusOptions}
        />
      </SubscriptionsFiltersSection>
      <SubscriptionsTable
        error={error}
        expandedRows={expandedRows}
        loading={loading}
        onSort={onSort}
        onToggleRow={onToggleRow}
        sortDirection={sortDirection}
        sortKey={sortKey}
        tableHeight={tableHeight}
        tableMinHeight={tableMinHeight}
        visibleRows={visibleRows}
      />
    </SubscriptionsPaper>
  )
}
